import type { BaseSlotName, SlotName } from "../config/platforms/types";

// this should follow `SlotNameWithSuffix` type
const repeatableSlotSuffix: RegExp = /_\d+$/;

export function getBaseSlotName(slotName: SlotName): BaseSlotName {
  return slotName.replace(repeatableSlotSuffix, "") as BaseSlotName;
}

export function isRepeatableSlotName(slotName: SlotName): boolean {
  return repeatableSlotSuffix.test(slotName);
}
